<template>
  <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 0.5V15.5L9 8L0 0.5Z" fill="#2F4554" />
  </svg>

</template>

<script>
export default {};
</script>
